import { Link } from "react-router-dom";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import Faq from "../../components/Faqs/Faqs";
import PrivacyHeroIcon from "../../assets/Privacy-Page-Assets/privacy-hero-icon.png";
import {
  LegalCallout,
  LegalContactGrid,
  LegalDocument,
  LegalIconList,
  LegalIntroBanner,
  LegalLead,
  LegalSection,
  LegalText,
} from "../legal/LegalContent";
import "../Privacy Policy/PrivacyPage.css";

const UPDATED = "22 September 2026";

const TermsPage = () => {
  return (
    <div>
      <NavBar />
      <div className="privacy-header">
        <div className="container">
          <div className="privacy-header-body">
            <h1 className="privacy-heading">Terms of Service</h1>
            <img src={PrivacyHeroIcon} alt="" />
          </div>
        </div>
      </div>

      <div className="legal-page-body">
        <p className="legal-updated">Last updated {UPDATED}</p>
        <LegalDocument>
          <LegalIntroBanner>
            These Terms govern belsoftsystems.com and related company pages
            operated by Belsoft Systems Ltd, a company registered in Nigeria. By
            using the site you agree to this contract. Separate terms apply to
            paid products (including BelCore and BelPower) and to statements of
            work for custom software.
          </LegalIntroBanner>

          <LegalSection title="1. Who we are">
            <LegalLead>
              Belsoft Systems Ltd designs, builds, and supports software,
              digital products, and training. Office: Ridds Plaza, Plot 740,
              Aguwan Anaekwe Street, Wuye Suite 046/47, Abuja, Nigeria.
            </LegalLead>
            <LegalContactGrid
              items={[
                {
                  label: "Support",
                  value: (
                    <a href="mailto:support@belsoftsystems.com">support@belsoftsystems.com</a>
                  ),
                },
                {
                  label: "Enquiries",
                  value: (
                    <a href="mailto:enquiry@belsoftsystems.com">enquiry@belsoftsystems.com</a>
                  ),
                },
              ]}
            />
          </LegalSection>

          <LegalSection title="2. What this site is">
            <LegalIconList
              variant="check"
              items={[
                "A marketing and information site for our company, services, academy, case studies, and blog.",
                "A way to contact us (hire us, join us, support, visibility packages).",
                "Links to product apps we operate, each of which has its own login and terms.",
              ]}
            />
            <LegalText>
              Content is general information, not legal, tax, or investment
              advice. Project fees, timelines, and deliverables are only binding
              when we sign a proposal or statement of work with you.
            </LegalText>
          </LegalSection>

          <LegalSection title="3. Acceptable use">
            <LegalIconList
              variant="check"
              items={[
                "Use the site lawfully and for genuine business or career enquiries.",
                "Keep form submissions accurate and professional.",
                "Respect copyright in our writing, images, code samples, and marks.",
              ]}
            />
            <LegalIconList
              variant="cross"
              items={[
                "Do not scrape, overload, or probe the site for vulnerabilities without written permission.",
                "Do not post malware, spam, or unlawful content through our forms or chat.",
                "Do not impersonate Belsoft or another person.",
              ]}
            />
          </LegalSection>

          <LegalSection title="4. Intellectual property">
            <LegalText>
              Belsoft, BelCore, BelPower, and related logos remain our
              trademarks. Website copy, design, and software we publish here are
              ours unless credited otherwise. Client work we deliver under a
              contract is owned as that contract says — usually you own the
              commissioned work; we retain our tools, libraries, and pre-existing
              IP.
            </LegalText>
          </LegalSection>

          <LegalSection title="5. Professional services">
            <LegalCallout>
              A message on this website is not a contract. Custom software,
              retainers, and academy enrolment start when both sides agree in
              writing (email confirmation, invoice, or signed SOW) and any
              deposit is paid.
            </LegalCallout>
            <LegalText>
              We may decline a project that is unlawful, unsafe, or outside our
              capacity. Refunds follow the written engagement terms for that
              project.
            </LegalText>
          </LegalSection>

          <LegalSection title="6. Product apps">
            <LegalText>
              BelCore, BelPower, and other Belsoft products are licensed under
              their own Terms of Service and Privacy Policy. Those documents
              control billing, uptime, and customer data inside the product.
            </LegalText>
          </LegalSection>

          <LegalSection title="7. Third-party links">
            <LegalText>
              The site may link to Google, social networks, payment providers, or
              client work. Their terms and privacy practices apply on their
              domains. We are not responsible for their content.
            </LegalText>
          </LegalSection>

          <LegalSection title="8. Disclaimer and liability">
            <LegalText>
              The website is provided “as is”. To the extent allowed by Nigerian
              law we exclude implied warranties and are not liable for
              indirect, incidental, or consequential loss from using the site.
              Nothing excludes liability for fraud or for death or personal
              injury caused by negligence where that exclusion is unlawful.
            </LegalText>
          </LegalSection>

          <LegalSection title="9. Governing law">
            <LegalText>
              These Terms are governed by the laws of the Federal Republic of
              Nigeria. Courts in Abuja, FCT, have exclusive jurisdiction, except
              that we may seek injunctive relief elsewhere to protect our IP.
            </LegalText>
          </LegalSection>

          <LegalSection title="10. Changes">
            <LegalText>
              We may update these Terms. Continued use of the site after the
              date above means you accept the current version.
            </LegalText>
          </LegalSection>

          <LegalSection title="11. Related">
            <LegalText>
              See our{" "}
              <Link to="/privacy-policy">Privacy Policy</Link>. If you do not
              agree, please do not use the site.
            </LegalText>
          </LegalSection>
        </LegalDocument>
      </div>

      <Faq />
      <Footer />
    </div>
  );
};

export default TermsPage;
